module.exports = __webpack_public_path__ + "img/icon-facebook.fdb1b69460dbf449091f6545c6a7e376.svg";